import { Exclude, Expose } from 'class-transformer';
import { Relationship } from './base-types';

@Exclude()
export class BaseItem<T> {
  @Expose()
  id!: string;
  @Expose()
  type!: string;
  @Expose()
  attributes!: T;
  @Expose()
  relationships!: Relationship;
}
